"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AtomLink = _interopRequireDefault(require("./AtomLink"));
var _Tag = _interopRequireDefault(require("./Tag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Page model module.
 * @module model/Page
 * @version 3.0
 */
var Page = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Page</code>.
   * @alias module:model/Page
   */
  function Page() {
    _classCallCheck(this, Page);
    Page.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Page, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Page</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Page} obj Optional instance to populate.
     * @return {module:model/Page} The populated <code>Page</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Page();
        if (data.hasOwnProperty('pageId')) {
          obj['pageId'] = _ApiClient["default"].convertToType(data['pageId'], 'Number');
        }
        if (data.hasOwnProperty('author')) {
          obj['author'] = _ApiClient["default"].convertToType(data['author'], 'String');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('legacyId')) {
          obj['legacyId'] = _ApiClient["default"].convertToType(data['legacyId'], 'String');
        }
        if (data.hasOwnProperty('legacyGroupId')) {
          obj['legacyGroupId'] = _ApiClient["default"].convertToType(data['legacyGroupId'], 'String');
        }
        if (data.hasOwnProperty('title')) {
          obj['title'] = _ApiClient["default"].convertToType(data['title'], 'String');
        }
        if (data.hasOwnProperty('dateCreated')) {
          obj['dateCreated'] = _ApiClient["default"].convertToType(data['dateCreated'], 'Date');
        }
        if (data.hasOwnProperty('dateModified')) {
          obj['dateModified'] = _ApiClient["default"].convertToType(data['dateModified'], 'Date');
        }
        if (data.hasOwnProperty('dateExpires')) {
          obj['dateExpires'] = _ApiClient["default"].convertToType(data['dateExpires'], 'Date');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('excerpt')) {
          obj['excerpt'] = _ApiClient["default"].convertToType(data['excerpt'], 'String');
        }
        if (data.hasOwnProperty('content')) {
          obj['content'] = _ApiClient["default"].convertToType(data['content'], 'String');
        }
        if (data.hasOwnProperty('slug')) {
          obj['slug'] = _ApiClient["default"].convertToType(data['slug'], 'String');
        }
        if (data.hasOwnProperty('language')) {
          obj['language'] = _ApiClient["default"].convertToType(data['language'], 'String');
        }
        if (data.hasOwnProperty('cmsSource')) {
          obj['cmsSource'] = _ApiClient["default"].convertToType(data['cmsSource'], 'String');
        }
        if (data.hasOwnProperty('operator')) {
          obj['operator'] = _ApiClient["default"].convertToType(data['operator'], 'String');
        }
        if (data.hasOwnProperty('href')) {
          obj['href'] = _ApiClient["default"].convertToType(data['href'], 'String');
        }
        if (data.hasOwnProperty('imageUrl')) {
          obj['imageUrl'] = _ApiClient["default"].convertToType(data['imageUrl'], 'String');
        }
        if (data.hasOwnProperty('completionTime')) {
          obj['completionTime'] = _ApiClient["default"].convertToType(data['completionTime'], 'Number');
        }
        if (data.hasOwnProperty('accessControlled')) {
          obj['accessControlled'] = _ApiClient["default"].convertToType(data['accessControlled'], 'Boolean');
        }
        if (data.hasOwnProperty('tags')) {
          obj['tags'] = _ApiClient["default"].convertToType(data['tags'], [_Tag["default"]]);
        }
        if (data.hasOwnProperty('_links')) {
          obj['_links'] = _ApiClient["default"].convertToType(data['_links'], [_AtomLink["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Page</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Page</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['author'] && !(typeof data['author'] === 'string' || data['author'] instanceof String)) {
        throw new Error("Expected the field `author` to be a primitive type in the JSON string but got " + data['author']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['legacyId'] && !(typeof data['legacyId'] === 'string' || data['legacyId'] instanceof String)) {
        throw new Error("Expected the field `legacyId` to be a primitive type in the JSON string but got " + data['legacyId']);
      }
      // ensure the json data is a string
      if (data['legacyGroupId'] && !(typeof data['legacyGroupId'] === 'string' || data['legacyGroupId'] instanceof String)) {
        throw new Error("Expected the field `legacyGroupId` to be a primitive type in the JSON string but got " + data['legacyGroupId']);
      }
      // ensure the json data is a string
      if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
        throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['excerpt'] && !(typeof data['excerpt'] === 'string' || data['excerpt'] instanceof String)) {
        throw new Error("Expected the field `excerpt` to be a primitive type in the JSON string but got " + data['excerpt']);
      }
      // ensure the json data is a string
      if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
        throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
      }
      // ensure the json data is a string
      if (data['slug'] && !(typeof data['slug'] === 'string' || data['slug'] instanceof String)) {
        throw new Error("Expected the field `slug` to be a primitive type in the JSON string but got " + data['slug']);
      }
      // ensure the json data is a string
      if (data['language'] && !(typeof data['language'] === 'string' || data['language'] instanceof String)) {
        throw new Error("Expected the field `language` to be a primitive type in the JSON string but got " + data['language']);
      }
      // ensure the json data is a string
      if (data['cmsSource'] && !(typeof data['cmsSource'] === 'string' || data['cmsSource'] instanceof String)) {
        throw new Error("Expected the field `cmsSource` to be a primitive type in the JSON string but got " + data['cmsSource']);
      }
      // ensure the json data is a string
      if (data['operator'] && !(typeof data['operator'] === 'string' || data['operator'] instanceof String)) {
        throw new Error("Expected the field `operator` to be a primitive type in the JSON string but got " + data['operator']);
      }
      // ensure the json data is a string
      if (data['href'] && !(typeof data['href'] === 'string' || data['href'] instanceof String)) {
        throw new Error("Expected the field `href` to be a primitive type in the JSON string but got " + data['href']);
      }
      // ensure the json data is a string
      if (data['imageUrl'] && !(typeof data['imageUrl'] === 'string' || data['imageUrl'] instanceof String)) {
        throw new Error("Expected the field `imageUrl` to be a primitive type in the JSON string but got " + data['imageUrl']);
      }
      if (data['tags']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['tags'])) {
          throw new Error("Expected the field `tags` to be an array in the JSON data but got " + data['tags']);
        }
        // validate the optional field `tags` (array)
        var _iterator = _createForOfIteratorHelper(data['tags']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _Tag["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      if (data['_links']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['_links'])) {
          throw new Error("Expected the field `_links` to be an array in the JSON data but got " + data['_links']);
        }
        // validate the optional field `_links` (array)
        var _iterator2 = _createForOfIteratorHelper(data['_links']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _AtomLink["default"].validateJSON(_item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} pageId
 */
Page.prototype['pageId'] = undefined;

/**
 * @member {String} author
 */
Page.prototype['author'] = undefined;

/**
 * @member {String} category
 */
Page.prototype['category'] = undefined;

/**
 * @member {String} legacyId
 */
Page.prototype['legacyId'] = undefined;

/**
 * @member {String} legacyGroupId
 */
Page.prototype['legacyGroupId'] = undefined;

/**
 * @member {String} title
 */
Page.prototype['title'] = undefined;

/**
 * @member {Date} dateCreated
 */
Page.prototype['dateCreated'] = undefined;

/**
 * @member {Date} dateModified
 */
Page.prototype['dateModified'] = undefined;

/**
 * @member {Date} dateExpires
 */
Page.prototype['dateExpires'] = undefined;

/**
 * @member {String} status
 */
Page.prototype['status'] = undefined;

/**
 * @member {String} excerpt
 */
Page.prototype['excerpt'] = undefined;

/**
 * @member {String} content
 */
Page.prototype['content'] = undefined;

/**
 * @member {String} slug
 */
Page.prototype['slug'] = undefined;

/**
 * @member {String} language
 */
Page.prototype['language'] = undefined;

/**
 * @member {String} cmsSource
 */
Page.prototype['cmsSource'] = undefined;

/**
 * @member {String} operator
 */
Page.prototype['operator'] = undefined;

/**
 * @member {String} href
 */
Page.prototype['href'] = undefined;

/**
 * @member {String} imageUrl
 */
Page.prototype['imageUrl'] = undefined;

/**
 * @member {Number} completionTime
 */
Page.prototype['completionTime'] = undefined;

/**
 * @member {Boolean} accessControlled
 */
Page.prototype['accessControlled'] = undefined;

/**
 * @member {Array.<module:model/Tag>} tags
 */
Page.prototype['tags'] = undefined;

/**
 * @member {Array.<module:model/AtomLink>} _links
 */
Page.prototype['_links'] = undefined;
var _default = exports["default"] = Page;